import { render, staticRenderFns } from "./NavigationButtons.vue?vue&type=template&id=42b9b3c1&"
import script from "./NavigationButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports